'use client';
import React from 'react';
import { CustomRegistration } from '@components/CustomRegistration';
import { getLeadGenerationOptions } from '@services/properties/getLeadGenerationOptions';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ParallaxBlock from '@components/ParallaxBlock';
import WildsLaunchContainer from '../WildsLaunchContainer';
import WildsLaunchFooter from '../WildsLaunchFooter';
import WildsLaunchLogo from '../WildsLaunchLogo';
import cn from './style.module.scss';
type Props = {
  logoImage: any;
  t: any;
  anchorId?: string;
};
export const THEWILETEASER_ID = 'wildsRegistrationID';
export default function VillasLaunchRegistration(props: any) {
  const { t } = props;
  const [countryCode, setCountryCode] = React.useState<{}[]>([]);
  const [nationalities, setNationalities] = React.useState<{}[]>([]);
  const leadMetaRequest = React.useMemo(() => getLeadGenerationOptions(), []);
  const setLeadMetaData = async () => {
    const { countryCode, nationalities } = await leadMetaRequest.getResponse();
    setNationalities(nationalities);
    setCountryCode(countryCode);
  };
  React.useEffect(() => {
    setLeadMetaData();
    return () => leadMetaRequest.abort();
  }, []);
  return (
    <Box component="section" className={cn.wildsLaunchRegistration}>
      <Stack className={cn.wildsRegistrationInner} id={THEWILETEASER_ID}>
        <Box className={cn.wildsRegistrationInner__content}>
          <WildsLaunchContainer>
            <Box className={cn.wildsRegistrationContainer}>
              <Box className={cn.wildsRegistrationContainer__theme}>
                <Box className={cn.registrationLogo}>
                  <ParallaxBlock animationType="zoomIn" animationDuration={500}>
                    <WildsLaunchLogo logoImage={props.logoImage} />
                  </ParallaxBlock>
                </Box>
              </Box>
              <Stack className={cn.wildsRegistrationContainer__forms}>
                <Box className={cn.wildsFormsHeading}>
                  <ParallaxText
                    variant="h3"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {t['registerHeading']}
                  </ParallaxText>
                  <ParallaxText
                    variant="p"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {t['registerContent']}
                  </ParallaxText>
                </Box>
                <Box className={cn.wildsFormsElement}>
                  <CustomRegistration
                    t={t}
                    successPopUpLink={props.successPopUpLink}
                    privacyPolicyLink={props.privacyPolicyLink}
                    termsAndConditionsLink={props.termsAndConditionsLink}
                    countryCodes={countryCode}
                    nationalities={nationalities}
                    className={cn.wildsRegistrationWrapper}
                    listClassName={cn.wildsRegistrationList}
                    blockClassName={cn.wildsRegistrationBlocks}
                    inputClassName={cn.wildsRegistrationInputs}
                    submitBlockClassName={cn.wildsSubmitBlock}
                    submitClassName={cn.wildsRegistrationButton}
                    authClassName={cn.wildsRegistrationAuth}
                    marksClassName={cn.wildsCheckMarck}
                    contentClassName={cn.wildsSuccessContent}
                    buttonClassName={cn.wildsSuccessButton}
                    formId="the-wilds-launch-lead-form"
                    formType="the-wilds-launch-lead-form"
                    projectName="The Wilds"
                    variant="modal"
                    theme="dark"
                  />
                </Box>
              </Stack>
            </Box>
          </WildsLaunchContainer>
        </Box>
        <Box className={cn.wildsRegistrationInner__controls}>
          <WildsLaunchFooter
            t={t}
            links={{
              termsAndConditions: props.termsAndConditionsLink,
              privacyPolicy: props.privacyPolicyLink,
              cookies: props.cookiesLink,
            }}
          />
        </Box>
      </Stack>
      <Box
        className={cn.wildsLaunchBottomItem}
        sx={{
          backgroundImage: `url("${props.registerBottomGraphics.url}")`,
        }}
      />
    </Box>
  );
}
